import { inject } from "@angular/core";
import { CanMatchFn, Router, UrlTree } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { firstValueFrom } from "rxjs";

interface CheckAccessResponse {
  hasAccess: boolean;
}

let cachedRedirect: string | null = null;

export const fallbackRedirectGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const http = inject(HttpClient);

  if (!cachedRedirect) {
    const hostname = window.location.hostname.toLowerCase();
    const isSmart = hostname.includes('smart') && !hostname.includes('nam') && !hostname.includes('rcip');
    const isRcip = hostname.includes('nam') || hostname.includes('rcip');

    if (isSmart) {
      // Su smart.* la home � sempre /agenda
      cachedRedirect = "/agenda";
    } else if (isRcip) {
      // Su rcip/nam la home � sempre /home (real-cost)
      cachedRedirect = "/home";
    } else {
      // Fallback generico: usa i permessi per decidere
      const endpoint = environment.apiUrl;

      try {
        const [payCor, realCost, s40] = await Promise.all([
          firstValueFrom(http.get<CheckAccessResponse>(`${endpoint}/rc/checkAccess`, { params: { ruleCode: 'payCor' } })),
          firstValueFrom(http.get<CheckAccessResponse>(`${endpoint}/rc/checkAccess`, { params: { ruleCode: 'realCost' } })),
          firstValueFrom(http.get<CheckAccessResponse>(`${endpoint}/rc/checkAccess`, { params: { ruleCode: 'S40' } })),
        ]);

        const hasRealCostOrS40 = (realCost?.hasAccess || s40?.hasAccess) ?? false;
        const hasPayCor = payCor?.hasAccess ?? false;

        if (hasRealCostOrS40) {
          cachedRedirect = "/home";
        } else if (hasPayCor) {
          cachedRedirect = "/pay-cor";
        } else {
          cachedRedirect = "/agenda";
        }
      } catch {
        cachedRedirect = "/agenda";
      }
    }
  }

  console.log(`[FallbackRedirect] Redirecting to: ${cachedRedirect}`);
  return router.createUrlTree([cachedRedirect]);
};